<template>
  <div>
    <div class="left_tree" v-show="showLeft">
      <a-spin :spinning="treeSpin" style="height: 100%">
        <div>
          <a-radio-group v-model="type" @change="handleChange">
            <a-radio-button value="dept">
              部门
            </a-radio-button>
<!--            <a-radio-button value="customer">-->
<!--              员工-->
<!--            </a-radio-button>-->
          </a-radio-group>
          <vxe-button @click="closeAll" style="margin-top: 12px">清空</vxe-button>
        </div>
        <div class="tree-box" v-if="type === 'dept'">
          <a-tree
              v-model="checkedKeys"
              :show-icon="true"
              checkable
              :expanded-keys="expandedKeys"
              :auto-expand-parent="autoExpandParent"
              :selected-keys="selectedKeys"
              :tree-data="treeData"
              :selectable="false"
              :replaceFields="{children:'children', title:'deptName', key:'deptId'}"
              @expand="onExpand"
              @check="onSelect"
          >
            <a-icon type="team" slot="dealer" style="color:#2fcfeb"/>
            <a-icon type="cluster" slot="region" style="color:#52c41a"/>
          </a-tree>
        </div>
        <div class="tree-box" v-if="type === 'customer'">
          <Tree :list="treeData" :selectedUser="selectedUser" :userName="''" :detph="0"
                @change="checkedUser"></Tree>
        </div>
      </a-spin>
    </div>
    <div class="right_table" :class="{showLeft:!showLeft}">
      <a-icon type="left-circle" class="close" @click="showLeft = false" v-if="showLeft"/>
      <a-icon type="right-circle" class="close" @click="showLeft = true" v-else/>

      <x-grid
          :id="'formList'"
          :rowId="rowId"
          :pager-config="pagerConfig"
          :form-config="formConfig"
          :url="url"
          :columns="columns"
          :checkbox-config="checkboxConfig"
          :toolbar-config="toolbarConfig"
          :print-config="printConfig"
          :export-config="exportConfig"
          ref="grid"
          :other-params="{'filter.orderByDesc.createDate':true,regionId,dealerId,deptId}"
          :cellClick="chooseRow"
          :cellDbClick="updateRow"
          @toolbar-addData="addRow"
          @toolbar-delData="delRow"
      >
        <template v-slot:operate="{row}">
          <a :download="row.activityName" :href="api.activity.GETACTIVITYQR + row.acitvityId + '?token=' + token">
            <vxe-button style="margin-right: 10px" size="mini" status="warning">下载二维码</vxe-button>
          </a>
          <!--        <vxe-button style="margin-right: 10px" size="mini" status="warning" @click="downloadCode(row)">下载二维码</vxe-button>-->
<!--          <vxe-button style="margin-right: 10px" size="mini" status="primary" @click="deleteRow(row)">删除</vxe-button>-->
        </template>
      </x-grid>
    </div>

    <!-- 详情页 -->
    <formModal
        title="活动详情"
        centered
        :closable="true"
        :footer="null"
        :maskClosable="false"
        :visible="editModalVisible"
        :width="1040"
    >
      <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
      <detailForm
          :rowId="editRowId"
          v-if="editModalVisible"
          ref="detailForm"
          @cancelled="closeEdit()"
          @saved="closeEdit(true)"
      >
      </detailForm>
    </formModal>


  </div>
</template>

<script>
import XGrid from "@/components/grid/XGrid";
import {GridMixin} from "@/utils/GridMixin";
import {formatter as fmt} from "@/utils/ebase-formatter";
import api from "@/services/api";
import {loadBaseCodeData} from "@/services/baseCodeSource";


console.info(fmt, loadBaseCodeData); //防止未用到报未定义错误 用到了可删除
import detailForm from "@/pages/web/activityManage/activityList/activityMDetail";
import {dataApi} from "@/services/activityManage/activityList";
// import {mapMutations} from "vuex";
//新增的
import {XEUtils} from "@/utils/common/FormBase";
import Tree from "@/components/picker/Tree";

//新增的结束
const fac = XGrid.factory;

//列表接口
const url = api.activity.ACTIVITY;

//主键
const rowId = "acitvityId";

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumnSeqDefault(),
  fac.makeColumn("activityNo", "活动编号", 140),
  fac.makeColumn("activityName", "活动名称", 140),
  fac.makeColumn("typeName", "活动类型", 120, "center"),
  fac.makeColumn("regionDeptName", "经理部", 120, "center"),
  fac.makeColumn("dealerDeptName", "经销商", 140, "center"),
  fac.makeColumn("createUserName", "创建人", 160, "center",''),
  fac.makeColumn("provinceName", "省份", 140, "center"),
  fac.makeColumn("cityName", "市", 100, "center"),
  fac.makeColumn("districtName", "区", 100, "center"),
  // fac.makeColumn("activityPlace", "活动地点", 160, "center",''),
  fac.makeColumn({field:"activityPlace", title:"活动地点", width:160, align:"center",resizable:'',formatter(res){
      if(res.cellValue == "null"){
      return ''
    }else {
        return res.cellValue
      }
    }}),
  fac.makeColumn("activityStartTime", "活动开始时间", 160, "center",),
  fac.makeColumn("activityEndTime", "活动结束时间", 160, "center",),
  fac.makeColumn("createDate", "申请时间", 160, "center",),
  fac.makeColumn({
    title: "操作",
    slots: {
      default: 'default'
    },
    align: 'center',
    width: 200,
    fixed: 'right'
  }),
];

const formConfig = fac.makeFormConfig(columns, [
  {field: "activityNo"},
  // {field: "regionDeptName"},
  // {field: "dealerDeptName"},
  {field: "activityName"},
  /*{
    field: "custCategoryName",
    type: "select",
    options: [],
  },
  {
    field: "custNatureName",
    type: "select",
    options: [],
  },*/
  {
    field: 'activityStartTime',
    title: "活动开始区间",
    type: 'dateRange',
  },
  {
    field: 'activityEndTime',
    title: "活动结束区间",
    type: 'dateRange',
  }
]);

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  export: true,
  import: false,
  delData: false,
  addData: false,
  templatelSlots: "toolbarBtns",
});

//可编辑表格约束
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

async function loadBaseData() {
  // let region = {
  //   isRegion: 1,
  //   isDealer: 0
  // }
  // let dealer = {
  //   isRegion: 0,
  //   isDealer: 1
  // }
}


export default {
  mixins: [GridMixin],
  authorize: {
    // addRow: "ADD",
    // updateRow: 'UPDATE',
    // delRow: 'DELETE',
    // importMethod:'IMPORT',
    // exportMethod:'EXPORT',
  },
  components: {
    detailForm,
    //新增的开始
    Tree
    //  新增的结束
  },
  computed: {
    // ...mapState("account", { currUser: "user" }),
  },
  data() {
    return {
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      pagerConfig,
      natureOptions: [],
      cstegoryOptions: [],
      regionOptions: [],
      dealerOptions: [],
      visible: false,
      value: 1,
      token: localStorage.getItem('token'),
      //  新增的
      regionId: '', dealerId: '', deptId: '',
      //角色树
      autoExpandParent: false,
      defaultExpandedKeys: [],
      selectedKeys: [],
      expandedKeys: [],
      checkedKeys: [],
      deptList: [],
      treeData: [],
      selectedUser: [],
      treeSpin: false,
      showLeft: false,
      type: 'dept',
      //  新增的结束
    };
  },
  mounted() {
    //  新增的
    this.init()
    //  新增的结束
  },
  methods: {
    loadBaseData,
    //下载二维码
    async downloadCode(row) {
      console.log(row);
      let result = await dataApi.getCode(row.acitvityId, JSON.parse(localStorage.getItem('admin.user')));
      console.log(result);
      // let file = new Blob(result);
      // console.log(file);
    },
    //删除
    deleteRow(row) {
      let _this = this;
      if (row.acitvityId) {
        this.$confirm({
          title: '确定要删除活动吗',
          content: '',
          async onOk() {
            let result = await dataApi.deleteAct(row.acitvityId);
            if (result.code === 200) {
              _this.$message.success('删除成功')
              _this.refresh()
            } else {
              _this.$message.error(result.msg)
            }
          },
          onCancel() {
            // console.log('Cancel');
          }
        });
      }


    },

    //  新增的
    init() {
      dataApi.popSelect().then(res => {
        this.treeData = XEUtils.toArrayTree(res.data, {
          parentKey: 'parentId',
          key: 'deptId',
          children: 'children'
        })
      })
    },
    handleChange() {
      this.closeAll()
      this.init()
    },
    closeAll() {
      this.checkedKeys = []
      //this.followUserId = ''
      this.regionId = ''
      this.dealerId = ''
      this.deptId = ''
      XEUtils.mapTree(this.treeData, item => {
        if (item.userList) {
          item.userList.map(user => {
            user.checked = false
          })
        }
        return item
      })
      this.selectedUser = []
      this.$nextTick(() => {
        this.refresh()
      })
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    onCheck(checkedKeys) {
      this.checkedKeys = checkedKeys;
    },
    onSelect(selectedKeys, {checkedNodes}) {
      this.selectedKeys = selectedKeys
      let regionId = [], dealerId = [], deptId = []
      checkedNodes.forEach(item => {
        if (item.data.props.isDealer === 1) {
          dealerId.push(item.key)
        } else if (item.data.props.isRegion === 1) {
          regionId.push(item.key)
        } else {
          deptId.push(item.key)
        }
      })
      this.regionId = regionId.toString()
      this.dealerId = dealerId.toString()
      this.deptId = deptId.toString()
      this.$nextTick(() => {
        this.refresh()
      })
    },
    checkedUser(user) {
      if (user.checked) {
        this.selectedUser.push(user)
      } else {
        this.selectedUser = this.selectedUser.filter(item => item.userId !== user.userId)
      }
      this.followUserId = this.selectedUser.map(item => {
        return item.userId
      }).toString()
      this.$nextTick(() => {
        this.refresh()
      })
    },

    //  新增的结束
  },
};
</script>

<style scoped lang="less">
/deep/ .ant-radio-group {
  display: flex;
  width: 100%;

  .ant-radio-wrapper {
    flex: 1;
  }

  .item {
    margin: 16px 0;
  }
}
//新增的开始

.left_tree {
  width: 260px;
  float: left;
  padding: 20px;
  height: calc(100vh - 48px - 64px);
  border-right: 1px solid #e0e0e0;
  background: #fff;
  overflow-y: scroll;
  overflow-x: hidden;
  position: relative;
}

.right_table {
  width: calc(100% - 260px);
  float: right;
  height: 100%;
  position: relative;

  .close {
    position: absolute;
    top: 50%;
    left: -18px;
    display: block;
    z-index: 1000;
    font-size: 36px;
    cursor: pointer;
    color: #fff;
    background-color: #bbb;
    border-radius: 18px;
  }
}

.showLeft {
  width: 100%;
}

//新增的结束
</style>
